import React from "react";

import * as Styled from "./styles";

interface TitlePageProps {
  title: string;
}

const TitlePage: React.FC<TitlePageProps> = ({ title }) => (
  <Styled.TitlePageContainer>{title}</Styled.TitlePageContainer>
);

export default TitlePage;
